import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/lib/supabase";

export const useTokenValidation = () => {
  const { toast } = useToast();

  const validateTokenBalance = async (tokenCost: number = 10) => {
    const { data: tokenData, error: tokenError } = await supabase
      .from('user_tokens')
      .select('token_balance')
      .single();

    if (tokenError) {
      console.error("Error checking token balance:", tokenError);
      throw new Error('Failed to check token balance');
    }

    console.log("Current token balance:", tokenData.token_balance);

    if (tokenData.token_balance < tokenCost) {
      toast({
        title: "Insufficient Tokens",
        description: "Please purchase more tokens to continue using the service.",
        variant: "destructive",
      });
      return false;
    }

    return true;
  };

  return { validateTokenBalance };
};